import { makeStyles } from "@mui/styles"
const useStyles = makeStyles(() => ({
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    animation: "$fadeIn 0.2s ease-out",
  },
  modalContent: {
    background: "white",
    borderRadius: "8px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
    maxWidth: "800px",
    width: "95%",
    maxHeight: "90vh",
    overflowY: "auto",
    animation: "$slideIn 0.3s ease-out",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 24px",
    borderBottom: "1px solid #e0e0e0",
  },
  modalTitle: {
    margin: 0,
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#333",
  },
  modalCloseButton: {
    background: "none",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "#666",
    padding: 0,
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  modalBody: {
    padding: "24px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
    },
  },
  formField: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  formFieldFullWidth: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    gridColumn: "span 2",
    "@media (max-width: 768px)": {
      gridColumn: "span 1",
    },
  },
  formLabel: {
    fontWeight: 500,
    color: "#333",
    fontSize: "0.875rem",
  },

  formInput: {
    padding: "12px",
    border: "1px solid #d0d0d0",
    borderRadius: "6px",
    fontSize: "0.875rem",
    transition: "border-color 0.2s, box-shadow 0.2s",
    backgroundColor: "white",
    "&:focus": {
      outline: "none",
      borderColor: "#00a78f",
      boxShadow: "0 0 0 3px rgba(0, 167, 143, 0.1)",
    },
    // Estilos específicos para select
    "&[type='date']": {
      colorScheme: "light",
    },
    "& option": {
      padding: "8px",
      backgroundColor: "white",
      color: "#333",
    },
  },
  formTextarea: {
    padding: "12px",
    border: "1px solid #d0d0d0",
    borderRadius: "6px",
    fontSize: "0.875rem",
    transition: "border-color 0.2s, box-shadow 0.2s",
    resize: "vertical",
    minHeight: "80px",
    fontFamily: "inherit",
    "&:focus": {
      outline: "none",
      borderColor: "#00a78f",
      boxShadow: "0 0 0 3px rgba(0, 167, 143, 0.1)",
    },
  },
  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "20px 24px",
    borderTop: "1px solid #e0e0e0",
    backgroundColor: "#f9f9f9",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  buttonPrimary: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    fontSize: "0.875rem",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s",
    minWidth: "100px",
    backgroundColor: "#00a78f",
    color: "white",
    "&:hover": {
      backgroundColor: "#008a75",
    },
    "@media (max-width: 768px)": {
      width: "100%",
    },
    "&:disabled": {
      backgroundColor: "#6c757d",
      color: "#ffffff",
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },

  buttonSecondary: {
    padding: "10px 20px",
    border: "1px solid #d0d0d0",
    borderRadius: "6px",
    fontSize: "0.875rem",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s",
    minWidth: "100px",
    backgroundColor: "transparent",
    color: "#666",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  "@keyframes fadeIn": {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  "@keyframes slideIn": {
    from: {
      transform: "translateY(-50px)",
      opacity: 0,
    },
    to: {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
}))

export default useStyles
